import type { DiffSummary } from '../../types'
import { formatMoney } from '../../ui/formatters'

interface SummaryGridProps {
  summary: DiffSummary
}

export function SummaryGrid({ summary }: SummaryGridProps) {
  const items = [
    { label: '基准版项目', value: summary.baselineItemCount, tone: 'neutral' },
    { label: '对比版项目', value: summary.targetItemCount, tone: 'neutral' },
    { label: '新增', value: summary.addedCount, tone: 'added' },
    { label: '删除', value: summary.removedCount, tone: 'removed' },
    { label: '修改', value: summary.changedCount, tone: 'changed' },
    { label: '未变化', value: summary.unchangedCount, tone: 'neutral' },
    { label: '待确认', value: summary.pendingCount, tone: 'pending' },
  ] as const

  return (
    <section className="summary-grid" aria-label="差异汇总" data-testid="summary-grid">
      {items.map((item) => (
        <div className={`summary-metric summary-metric--${item.tone}`} key={item.label}>
          <span>{item.label}</span>
          <strong>{item.value.toLocaleString('zh-CN')}</strong>
        </div>
      ))}
      <div className="summary-metric summary-metric--impact">
        <span>已确认净金额影响</span>
        <strong>{formatMoney(summary.confirmedNetAmountImpact, '¥0.00')}</strong>
        <small>待确认金额 {formatMoney(summary.pendingAmountImpact, '¥0.00')}</small>
      </div>
    </section>
  )
}
